import './trusted.component.js';